export const MOCK_BUILDINGS = [
	{
		id: '040010001',
		BuildingName: 'Kingdom Tower',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010002',
		BuildingName: 'Riyadh Gallery',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010003',
		BuildingName: 'Centria',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010004',
		BuildingName: 'Lana Tower',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010005',
		BuildingName: 'Mazaya (previously Global Tower) - Maather road',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010006',
		BuildingName: 'Prestige Center',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010007',
		BuildingName: 'Tawaniyah Tower',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010008',
		BuildingName: 'Akaria Plaza',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010009',
		BuildingName: 'Al Dughaither Center',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010010',
		BuildingName: 'Al Munajjem Tower (Al Ibdaa)',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010011',
		BuildingName: 'Anoud 2',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010012',
		BuildingName: 'Arcade Center',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010013',
		BuildingName: 'Azizia Mall',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010014',
		BuildingName: 'Canary Building',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010015',
		BuildingName: 'Centria Center',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010016',
		BuildingName: 'Elegance',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010017',
		BuildingName: 'Faisaliah',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010018',
		BuildingName: 'Faisaliyah Mall',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010019',
		BuildingName: 'Hammad Tower',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010020',
		BuildingName: 'Hayat Mall',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010021',
		BuildingName: 'KFF',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010022',
		BuildingName: 'Kingdom Center',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010023',
		BuildingName: 'Legend Tower',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010024',
		BuildingName: 'Localizer Center',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010025',
		BuildingName: 'Nakheel Mall',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010026',
		BuildingName: 'Olaya Towers',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010027',
		BuildingName: 'Olaya Towers',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010028',
		BuildingName: 'Sahara Mall',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010029',
		BuildingName: 'Seadan',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010030',
		BuildingName: 'Sky Tower',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010031',
		BuildingName: 'Smart Tower',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010032',
		BuildingName: 'Tawaren',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010033',
		BuildingName: 'The Plaza (Akariya 4)',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040010034',
		BuildingName: 'Ziab Tower',
		CountryName: 'KSA',
		DistrictId: '04001',
		DistrictName: 'Al Olaya',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040020001',
		BuildingName: 'Madarat',
		CountryName: 'KSA',
		DistrictId: '04002',
		DistrictName: 'Al Malaz',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040020002',
		BuildingName: 'Othaim Mall Khurais',
		CountryName: 'KSA',
		DistrictId: '04002',
		DistrictName: 'Al Malaz',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040030001',
		BuildingName: 'Mashareq',
		CountryName: 'KSA',
		DistrictId: '04003',
		DistrictName: 'Ash Shomaisi',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040040001',
		BuildingName: 'City Tower',
		CountryName: 'KSA',
		DistrictId: '04004',
		DistrictName: 'Al Maather',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040040002',
		BuildingName: 'Grand Tower',
		CountryName: 'KSA',
		DistrictId: '04004',
		DistrictName: 'Al Maather',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040040003',
		BuildingName: 'Moon Tower',
		CountryName: 'KSA',
		DistrictId: '04004',
		DistrictName: 'Al Maather',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040040004',
		BuildingName: 'Nakheel Tower',
		CountryName: 'KSA',
		DistrictId: '04004',
		DistrictName: 'Al Maather',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040040005',
		BuildingName: 'Panorama Mall',
		CountryName: 'KSA',
		DistrictId: '04004',
		DistrictName: 'Al Maather',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040040006',
		BuildingName: 'Tatweer Tower',
		CountryName: 'KSA',
		DistrictId: '04004',
		DistrictName: 'Al Maather',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040040007',
		BuildingName: 'Home Office',
		CountryName: 'KSA',
		DistrictId: '04004',
		DistrictName: 'Al Maather',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040040008',
		BuildingName: 'Jumaiah',
		CountryName: 'KSA',
		DistrictId: '04004',
		DistrictName: 'Al Maather',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040050001',
		BuildingName: 'A01',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040050003',
		BuildingName: 'A06',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040050024',
		BuildingName: '304',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040050025',
		BuildingName: '305',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040050028',
		BuildingName: '311',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040050047',
		BuildingName: '507',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040050048',
		BuildingName: '508',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040105001',
		BuildingName: 'Brand Tower',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040105002',
		BuildingName: 'Nakhla Tower',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040105003',
		BuildingName: 'Riyadh Park',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040105004',
		BuildingName: 'Rubeen Plaza',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040105005',
		BuildingName: 'Tala Mall',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040105006',
		BuildingName: 'Tamkeen Tower',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040105007',
		BuildingName: 'The Boulevard',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Shimalai Riyadh-Other',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040060001',
		BuildingName: 'Dabab Centre',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Al Batha',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040060002',
		BuildingName: 'Futuro Tower',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Al Batha',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040070001',
		BuildingName: 'Granada Business Park',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Ar Rawdah',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040070002',
		BuildingName: 'Granada Center',
		CountryName: 'KSA',
		DistrictId: '04005',
		DistrictName: 'Ar Rawdah',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040070003',
		BuildingName: 'Khurais Mall',
		CountryName: 'KSA',
		DistrictId: '04006',
		DistrictName: 'Ar Rawdah',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040070004',
		BuildingName: 'Riyadh Business Gate',
		CountryName: 'KSA',
		DistrictId: '04006',
		DistrictName: 'Ar Rawdah',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040080001',
		BuildingName: 'Othaim Mall Exit 14',
		CountryName: 'KSA',
		DistrictId: '04008',
		DistrictName: 'An Naseem',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040120001',
		BuildingName: 'AlQasr Mall',
		CountryName: 'KSA',
		DistrictId: '04007',
		DistrictName: 'Al Uraija',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040120002',
		BuildingName: 'Platinum 2',
		CountryName: 'KSA',
		DistrictId: '04012',
		DistrictName: 'Al Uraija',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '040120003',
		BuildingName: 'Salam Mall',
		CountryName: 'KSA',
		DistrictId: '04012',
		DistrictName: 'Al Uraija',
		CityId: '04',
		CityName: 'Riyadh',
	},
];

export const mockCities = [
	{
		id: '01',
		CityName: 'Dubai',
	},
	{
		id: '02',
		CityName: 'Abudhabi',
	},
	{
		id: '03',
		CityName: 'Jeddah',
	},
	{
		id: '04',
		CityName: 'Riyadh',
	},
	{
		id: '05',
		CityName: 'Damam',
	},
	{
		id: '06',
		CityName: 'Mecca',
	},
	{
		id: '07',
		CityName: 'Cairo',
	},
	{
		id: '08',
		CityName: 'Casablanca',
	},
];

export const mockCommunities = [
	{
		id: '04004',
		DistrictName: 'Al Maather',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04001',
		DistrictName: 'Al Olaya',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04002',
		DistrictName: 'Al Malaz',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04006',
		DistrictName: 'Al Bathaa',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04003',
		DistrictName: 'Ash Shamaisi',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04105',
		DistrictName: 'Shimalai Riyadh-Other',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04007',
		DistrictName: 'Ar Rawdah',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04008',
		DistrictName: 'An Naseem',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04009',
		DistrictName: 'As Sulai',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04010',
		DistrictName: 'Al Aziziyah',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04011',
		DistrictName: 'Ash Shifa',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04012',
		DistrictName: 'Al Uraija',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04013',
		DistrictName: 'Namar',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04014',
		DistrictName: 'Al Irqah',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04201',
		DistrictName: 'Ad Diriyah',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04020',
		DistrictName: 'As Safarat',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04016',
		DistrictName: 'King Khalid Airport',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
	{
		id: '04105',
		DistrictName: 'Shimalai Riyadh-KAFD',
		CountryName: 'KSA',
		CityId: '04',
		CityName: 'Riyadh',
	},
];

export interface IBuilding {
	id: string;
	BuildingName: string;
	CountryName: string;
	DistrictId: string;
	DistrictName: string;
	CityId: string;
	CityName: string;
}

export interface ICity {
	id: string;
	CityName: string;
}

export interface IDistrict {
	id: string;
	DistrictName: string;
	CountryName: string;
	CityId: string;
	CityName: string;
}

export const filterData = [
	{ id: 'RS6-P15D', label: 'Plot' },
	{ id: 'RS6-P15B', label: 'Plot' },
	{ id: 'RS1-PS1', label: 'Plot' },
	{ id: 'RS2-PS1', label: 'Plot' },
	{ id: 'RW-U-4-007', label: 'Plot' },
];
